const TITLE = {
  google: 'Google has updated its Browser Policy.',
  outlook: "It looks like you're using a social app.",
};

const contentMapping = {
  ios: {
    google: {
      facebook: { title: TITLE.google, action: 'external browser',   arrow: 'top',    showFooter: true  },
      instagram: { title: TITLE.google, action: 'external browser', arrow: 'top',    showFooter: true  },
      linkedin:  { title: TITLE.google, action: 'Browser',          arrow: 'top',    showFooter: true  },
      twitter:   { title: TITLE.google, action: 'Chrome', arrow: 'bottom-center', showFooter: false, msg: "Please tap ECAL.com below and 'Open in browser'" },
      default:   { title: TITLE.google, action: 'system browser',   arrow: 'top',    showFooter: true  },
    },
    outlook: {
      facebook:  { title: TITLE.outlook, action: 'external browser',   arrow: 'top',    showFooter: true  },
      instagram: { title: TITLE.outlook, action: 'external browser', arrow: 'top',    showFooter: true  },
      linkedin:  { title: TITLE.outlook, action: 'Browser',          arrow: 'top', showFooter: true },
      twitter:   { title: TITLE.outlook, action: 'Chrome', arrow: 'bottom-center', showFooter: false, msg: "Please tap ECAL.com below and 'Open in browser'" },
      default:   { title: TITLE.outlook, action: 'system browser',   arrow: 'top',    showFooter: true  },
    },
    apple: {
      twitter: { title: TITLE.outlook, action: 'Chrome', arrow: 'bottom-center', showFooter: false, msg: "Please tap ECAL.com below and 'Open in browser'" },
      default: { title: TITLE.outlook, action: 'system browser', arrow: 'top', showFooter: true },
    },
  },

  android: {
    google: {
      linkedin:  { title: TITLE.google, action: 'Browser',        arrow: 'top', showFooter: true },
      facebook:  { title: TITLE.google, action: 'external browser', arrow: 'top', showFooter: true },
      instagram: { title: TITLE.google, action: 'Chrome',         arrow: 'top', showFooter: true },
      default:   { title: TITLE.google, action: 'Browser',        arrow: 'top', showFooter: true },
    },
    outlook: {
      default: { title: TITLE.outlook, action: 'Browser', arrow: 'top', showFooter: true },
    },
  },
};

export function getContentGuideFor (os, calendar, options = {}) {
  let contentMap = contentMapping[os];
  if (!contentMap) {
    contentMap = contentMapping.ios;
  }

  if (calendar === 'google') {
    contentMap = contentMap.google || contentMapping.ios.google;
  } else if (calendar === 'apple') {
    contentMap = contentMap.apple || contentMap.outlook || contentMapping.ios.outlook;
  } else {
    contentMap = contentMap.outlook || contentMapping.ios.outlook;
  }

  let content = contentMap.default;

  if (options.app) {
    content = contentMap[options.app] || contentMap.default;
  }

  return content;
}
